import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { ToastStateHandler, UserApi } from '../../../api';
import { OrganizationMembersCount } from '../../../commonTypes/user.types';

const useHttpGetOrganizationMembersCountOnMount = (from: string, to: string) => {
    const userApi: UserApi = useContainer(UserApi);
    const [data, setData] = useState<OrganizationMembersCount>({ totalMembers: 0, joinedAtCount: 0 });
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setReady] = useState(false);

    useEffect(() => {
        const { exec, abort } = userApi.getOrganizationMembersCount({
            query: { from, to },
            onSuccess: res => setData(res.body),
            onError: () => toastHandler.push('warn', 'Absent count', 'Failed to fetch users count'),
            onFinally: () => setReady(true),
        });
        exec();
        return abort;
    }, [userApi]);

    return { data, isReady };
};

export default useHttpGetOrganizationMembersCountOnMount;
